import React, { PureComponent } from 'react';

import OneVisualLayout from '../../layouts/one-visual';

import FinancialTargets from '../../../../../components/performance-feedback/components/FinancialTargets';

class ResultsAreInStep2 extends PureComponent {
  render() {
    const { activeRound, gamesTargets } = this.props;

    return (
      <OneVisualLayout
        section="RESULTS ARE IN!"
        title="Financial Goals"
        paragraph1={(
          <p>These were the financial metrics and targets that drove team scores for Round <b>{activeRound}</b></p>
        )}
        visual={(
          <FinancialTargets
            round={activeRound}
            financialTargets={gamesTargets}
            showTableOnly={true}
          />
        )}
      />
    );
  }
}

export default ResultsAreInStep2;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/results-are-in/step2.js